<script setup>
import axios  from "axios";
import proinfo from "@/components/common/Productinfo.vue";
import navi from '@/components/relmng/MngNavi.vue'
import rellist from '@/components/relmng/Rellist.vue'
axios.defaults.baseURL = 'https://qlipper.jp/';
axios.defaults.withCredentials = true;
axios.defaults.crossDomain = true;
</script>
<template>
<div style="display:flex">
    <div class="reditormain">
        <rellist ref="list" />
    </div>
	<div>
    <div class="feditornavi">
        <navi  v-on:menu="relmenu($event)" />
    </div>
	</div>
    <proinfo
        ref="pi"
        v-on:setproduct="setpro($event)"
    >
    </proinfo>
</div>
</template>
<script>
export default {
  head: {
    title() {
      return {
        inner: 'リリース一覧',
        separator: '|',
        complement: 'PR効果測定 Qlipper',
      }
    },
      link:
        [
          { rel: 'stylesheet', href: "https://qlipper.jp/css/common_vuetify.css" },
          { rel: 'stylesheet', href: "https://qlipper.jp/css/vuetify_custom.css" },
          { rel: 'stylesheet', href: "https://qlipper.jp/css/relcreate.css" },
          { rel: 'stylesheet', href: "./css/relmng.css" },
          { rel: 'stylesheet', href: "https://cdn.jsdelivr.net/npm/@mdi/font@7.3.67/css/materialdesignicons.min.css" },
        ],
  },
      methods :{
        relmenu : function(data){
            switch(data.index)
            {
            case 0:
                this.doc_select();
                break;
            case 1:
                this.schedule('');
                break;
            case 2:
                this.events('');
                break;
            case 3:
                this.$refs.pi.add_open();
                break;
            case 4:
                break;
            default:
                break;
            }
        },
        doc_select : function(){
            this.$router.push({name: 'Edit', params: {selected_id: ''}});
        },
        schedule : function(id) {
            this.$refs.list.schedule(id);
        },
        events : function(){
            this.$router.replace('Cal');
        },
        product_load : async function(){
            var params = new URLSearchParams();
            await axios.post("/api/gpt/get_product",params)
            .then(response => {
                response.data;
                this.$store.commit("product_list/set_product_list",response.data);
                this.$store.commit("product_list/set_load");
            }).catch((error) => {
                window.location.href = 'https://qlipper.jp/login';
                console.error('失敗です', error);
            });
        },
    },
    created : function(){
        this.product_load();
    },

}
</script>
